import { useNavigate } from "react-router-dom";

const TourCard = ({ tour }) => {
	const navigate = useNavigate();

	const handleViewTour = () => {
		navigate(`/${tour.band}`);
	};

	return (
		<div
			className='d-flex flex-column px-3 align-items-center tour-card'
			id='flyer'>
			<img
				src={tour.flyer_gira}
				alt={`${tour.band_name} - ${tour.tour_name}`}
				width={350}
				height={350}
			/>

			<button
				type='button'
				className='btn'
				id='boton-inicio'
				onClick={handleViewTour}>
				Ver gira de {tour.band_name}
			</button>
			<hr />
		</div>
	);
};

export default TourCard;
